import { Navigate } from 'react-router-dom';

/**
 * Platform 管理应用首页。业务子应用自行处理各自的默认路由。
 */
export function HomePage() {
  return <Navigate to="/app/admin/app-center" replace />;
}
